import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';


export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '회사 소개', href: '#about' },
    { label: '사업 분야', href: '#business' },
    { label: '파트너', href: '#partners' },
    { label: '문의하기', href: '#contact' },
  ];

  const handleNavClick = (href: string) => {
    setIsMobileMenuOpen(false);
    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-sm py-3' : 'bg-transparent py-6'
    }`}>
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img 
            src="https://public.readdy.ai/ai/img_res/c9e35ef3-6870-488e-85b2-c6c685056c55.png" 
            alt="Fixcope"
            className="h-8 w-auto"
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-10">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleNavClick(item.href)}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-600 hover:text-[#E8650A]' : 'text-white/90 hover:text-white'
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden lg:flex items-center gap-3">
          {/* Language Switcher */}
          <Link
            to="/en"
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold transition-all whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'text-gray-500 hover:text-[#E8650A] border border-gray-200 hover:border-[#E8650A]'
                : 'text-white/80 hover:text-white border border-white/30 hover:border-white'
            }`}
          >
            <i className="ri-global-line text-sm"></i>
            EN
          </Link>
          <button
            onClick={() => handleNavClick('#contact')}
            className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'bg-[#E8650A] text-white hover:bg-[#C95508]'
                : 'bg-white/15 backdrop-blur-sm text-white border border-white/30 hover:bg-white/25'
            }`}
          >
            문의하기
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="lg:hidden p-2"
        >
          <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
            isScrolled ? 'text-gray-900' : 'text-white'
          }`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden mt-2 mx-4 py-4 bg-white rounded-xl shadow-lg border border-gray-100">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleNavClick(item.href)}
              className="block w-full text-left px-6 py-3 text-gray-700 hover:text-[#E8650A] hover:bg-gray-50 text-sm font-medium transition-colors cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <div className="px-6 pt-3 flex flex-col gap-2">
            <Link
              to="/en"
              className="w-full text-center px-5 py-2 border border-gray-200 text-gray-600 rounded-lg text-sm font-semibold hover:border-[#E8650A] hover:text-[#E8650A] transition-colors whitespace-nowrap cursor-pointer"
            >
              English (EN)
            </Link>
            <button
              onClick={() => handleNavClick('#contact')}
              className="w-full px-5 py-2.5 bg-[#E8650A] text-white rounded-lg text-sm font-semibold hover:bg-[#C95508] transition-colors whitespace-nowrap cursor-pointer"
            >
              문의하기
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
